import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useSendEvents from "../hooks/useSendEvents";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Sectors = ({ data, bg }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const navigate = useNavigate();
  const { handleEvent, handleEventWithCallBackAction, handleEventWithCallBackRedirect } = useSendEvents();

  const products = [
    "/nuestros-productos/getsmart",
    "/nuestros-productos/gtapp",
    "/nuestros-productos/getadvance",
    "/nuestros-productos/getmini",
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const dispatchAction = (href, event) => {
    if (location.pathname === "/nuestros-productos/sobregetnet") {
      handleEventWithCallBackRedirect(
        () =>
          handleEvent({
            event: "select_content",
            action_type: "click on cta",
            selection_name: "know more",
            module_type: "specialized solutions",
            page_category: "about getnet",
            value: event,
          }),
        href
      );
    } else if (products.includes(href)) {
      handleEventWithCallBackRedirect(
        () =>
          handleEvent({
            event: "select_content",
            action_type: "click on cta",
            selection_name: "know more",
            module_type: "sectors section",
            page_category: "product page",
            value: event,
          }),
        href
      );
    } else {
      navigate(href);
    }
  };

  return (
    <section className={`${bg ? "bg-white" : "bg-[#f5f9fb]"} py-20 xs:py-1`}>
      <div className="text-center mx-auto max-w-7xl xs:p-4 2xl:p-8">
        <h1 className="text-center text-6xl xs:text-3xl mb-3 lg:ml-5 xs:ml-0 pb-4">{data.title}</h1>
        <p className="text-[#767676] text-xl xs:text-medium xs:px-2 2xl:text-center mx-auto xs:mt-4">
          {data.text}
        </p>
        {data.textTwo && <p className="text-[#767676] text-xl xs:text-medium">{data.textTwo}</p>}

        <div className="mt-20 relative">
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            slidesPerView={isMobile ? 1 : 3}
            spaceBetween={30}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="w-full"
          >
            {data.sector.map((sector, index) => (
              <SwiperSlide key={index}>
                <div className={`${bg ? "bg-[#faf9f9]" : "bg-white"}`}>
                  <div className="h-80">
                    <img
                      src={sector.img}
                      alt={sector.titleCard}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="text-start p-4">
                    <h3 className="text-lg font-bold mb-4">{sector.titleCard}</h3>
                    <p className="h-24 text-lg mb-8">{sector.textCard}</p>
                    <button
                      className="action-terciary pt-3 text-sm"
                      onClick={() => dispatchAction(sector.link, sector.event)}
                    >
                      <a className="text-[#ec0000] no-underline font-semibold">
                        {sector.actionTerciary}
                      </a>
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
            <div className="swiper-pagination !relative !mt-6 !mb-2 !z-10 flex justify-center" />
          </Swiper>

          <style>{`
            .swiper-pagination-bullet {
              width: 10px;
              height: 10px;
              margin: 0 6px;
              opacity: 0.5;
              background-color: black;
              border-radius: 100%;
              transition: all 0.3s ease;
            }
            .swiper-pagination-bullet-active {
              opacity: 1;
              background-color: #EC0000 !important;
            }
          `}</style>
        </div>
      </div>
    </section>
  );
};

export default Sectors;
